<template lang="pug">
.container-guides(id="Guides-container")
  .guide-horizontal(
    v-for='guide in guides.horizontal',
    :style="{ top: guide.screen + 'px' }",
    :class="{ viewportguide: guide.viewport }",
  )
  .guide-vertical(
    v-for='guide in guides.vertical',
    :style="{ left: guide.screen + 'px', height: viewportHeight + 'px' }",
    :class="{ viewportguide: guide.viewport }",
  )
</template>

<script>
export default {
  props: ['guides', 'viewportHeight'],
  mixins: [],
  components: {
  },
  created () {
  },
  watch: {
    foo: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: []
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../../theme-m4b/src/common/var.scss";
.container-guides {
  position: relative;
  .guide-horizontal, .guide-vertical {
    position: absolute;
    z-index: 100;
    &.viewportguide {
      opacity: 0;
    }
  }
  .guide-vertical {
    border-left: 1px solid red;
    width: 1px;
  }
  .guide-horizontal {
    border-top: 1px solid red;
    width: 100%;
    height: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/LayoutEditor/Guides.vue